import dynamic from 'next/dynamic'
// Components
import LandingCover from '@/components/landings/LandingCover'
import Featured from '@/components/landings/Featured'
import CustomerReview from '@/components/search/CustomerReview'
import NationWide from '@/components/landings/NationWide'
import Categories from '@/components/home/Categories'
import OurPartners from '@/components/ourPartners'

import Nearby from './NearBy'
import BreedsList from './BreedList'
import CitiesList from './CitiesList'
// Utils
import useMediaQuery from '@/utils/publicApi'

import { DogsLandingsContext } from '@context/dogsLandingsContext'

import styles from './StateLanding.module.scss'
import VideoTestimonials from '../home/VideoTestimonials'
// Dynamic
const How = dynamic(() => import('@/components/home/How'))
const Why = dynamic(() => import('@/components//home/Why'))
const PuppyQuizBanner = dynamic(
  () => import('@/components/search/PuppyQuizBanner')
)
const Explore = dynamic(() => import('@/components/home/BreedListExplorer'))

export const StateLanding = ({
  breedsByState,
  breedsNationWide,
  variables,
  landingType,
  dogs,
  categoriesData,
  breedsExplorer,
  nearbyDogs,
  statesData,
}) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  if (landingType !== 'state') return null

  const stateFacts = statesData?.state[0]

  return (
    <DogsLandingsContext.Provider value={{ variables, landingType }}>
      <LandingCover
        state={stateFacts}
        landingType={landingType}
        variables={variables}
      />
      {/* TODO: update near states */}
      <Featured
        title={`Our Puppies in ${variables?.stateName}`}
        dogs={dogs}
        landingType={landingType}
        variables={variables}
        breed={variables?.breed}
        city={variables?.city}
      />
      <div id="relatedBreeds" />

      <Nearby
        title="Puppies in Nearby Locations"
        nearbyDogs={nearbyDogs}
        isMobile={isMobile}
      />

      <NationWide
        title="Explore puppies nationwide!"
        allDogs={breedsNationWide}
        hasBreeds={false}
        slug={variables?.stateSlug}
      />

      <Explore
        id="relatedDogBreeds"
        title="Explore popular breeds nationwide"
        className={styles.section}
        breeds={breedsExplorer}
      />

      <div className={styles.section}>
        <Categories
          title="Explore dog categories nationwide"
          categories={Object.keys(categoriesData).filter(
            (c) => c !== '__typename'
          )}
          isLanding
        />
      </div>

      <div className={styles.section}>
        <CustomerReview />
        <VideoTestimonials />
      </div>
      <How />
      <Why />
      <div className={styles.section}>
        <OurPartners />
        <PuppyQuizBanner />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <CitiesList
          type="state"
          title="Find Puppies in Nearby Cities"
          more="View all cities"
          less="View less cities"
        />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <BreedsList
          breedsData={breedsByState}
          stateName={variables?.stateName}
          stateSlug={variables?.stateSlug}
          title={`Explore by Breed in ${variables?.stateName}`}
          withDogs={breedsByState?.withDogs}
          withoutDogs={breedsByState?.withoutDogs}
          type="inState"
          more="View all breeds"
          less="View less breeds"
        />
      </div>
    </DogsLandingsContext.Provider>
  )
}

export default StateLanding
